import React from "react";
import { Link } from "react-router-dom";

const SignIn = () => {
  return (
    <div>
      <h1>sign in page</h1>
      <Link to="/">Home</Link>
    </div>
  );
};

export default SignIn;
